import LayoutContainer from 'components/Common/LayoutContainer'
import Divider from 'LuxKit/Divider'
import Group from 'components/utils/Group'
import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import zIndex from 'styles/tools/z-index'
import LoadingBox from 'components/Common/Loading/LoadingBox'
import ChatHeader from 'supportAssistant/components/Chat/ChatHeader'
import ChatContent from 'supportAssistant/components/Chat/ChatContent'
import MessageInput from 'supportAssistant/components/Chat/MessageInput'
import useChatState from 'supportAssistant/hooks/useChatState'
import { useSimplePolling } from 'supportAssistant/hooks/useSimplePolling'

const Container = styled(Group)`
  min-height: 100dvh;
`

const Body = styled(LayoutContainer)`
  flex-grow: 1;
`

const HeaderContainer = styled(LayoutContainer)`
  position: sticky;
  top: 0;
  background-color: ${props => props.theme.palette.neutral.default.eight};
  z-index: ${zIndex.stickyHeader};
`

function Chat() {
  const [messages, typing, , fetchingChatMessages] = useChatState()
  const hasUserMessage = messages.some(m => m.sender === 'user')
  const isEmptyState = !fetchingChatMessages && !hasUserMessage

  useSimplePolling()

  return (
    <Container direction="vertical">
      <HeaderContainer>
        <ChatHeader />
        <Divider direction="horizontal" kind="primary" />
      </HeaderContainer>
      <Body size="md">
        <ChatContent />
        {!isEmptyState && (
          <>
            {fetchingChatMessages && <LoadingBox style={{ height: rem(44), width: '100%' }} />}
            {!fetchingChatMessages && <MessageInput isTyping={typing} />}
          </>
        )}
      </Body>
    </Container>
  )
}

export default Chat
